"use client";
import { useVisitStats } from "@/hooks/useVisitStats";

function Visits() {
    const { data: visitStats, isLoading, isError } = useVisitStats();

    if (isLoading || isError) return null;

    return (
        <div className="text-center">
            <h2 className="pt-4 text-lg">
                Total Visiters: {visitStats?.total?.count}
            </h2>
        </div>
    );
}
export default Visits;
